import { Component, Input, OnInit } from '@angular/core';
import { ScoreInfoType } from '../../constants-types/Enums';
import {
    BehavioralFactor,
    behavioralFactorLabelMap
} from '../../core-data-model/BehavioralFactor.model';
import { Pattern } from '../../core-data-model/Pattern.model';
import { SVGUtilities } from '../../core-utilities/SVG.utility';
import { Util } from '../../core-utilities/Util';
import { ConfigurationService } from '../../system-configuration/Configuration.service';
import { TranslationService } from '../../translations';

@Component({
    selector: '[singleBehavioralPattern]',
    template: `
        <svg:defs>
            <svg:path
                id="letterA"
                d="M1.65,-8.99l5.69,15.21h-3.47L2.72,2.8h-5.69l-1.19,3.39h-3.37l5.75-15.21Zm.19,9.33L-0.07,-5.2h0l-2,5.58Z"
                style="fill:#0092c8"
            />
            <svg:path
                id="letterB"
                d="M1.13,-7.32a9.46,9.46,0,0,1,2,.19,4.28,4.28,0,0,1,1.54.63,2.93,2.93,0,0,1,1,1.16,4.08,4.08,0,0,1,.35,1.79,3.33,3.33,0,0,1-.52,1.92A3.78,3.78,0,0,1,3.92,0.32a3.66,3.66,0,0,1,2.1,1.42,4.65,4.65,0,0,1,.25,4.43,3.88,3.88,0,0,1-1.2,1.37,5.31,5.31,0,0,1-1.73.79,7.76,7.76,0,0,1-2,.26h-7.37V-7.32Zm-.43,6.16a2.41,2.41,0,0,0,1.47-.43,1.61,1.61,0,0,0,.57-1.39,1.77,1.77,0,0,0-.19-.87,1.43,1.43,0,0,0-.51-.53,2.2,2.2,0,0,0-.74-.27,5,5,0,0,0-.86-.07h-3.13v3.56Zm.19,6.46a4.46,4.46,0,0,0,.94-.1,2.29,2.29,0,0,0,.79-.32,1.61,1.61,0,0,0,.54-.61,2.1,2.1,0,0,0,.2-1,2,2,0,0,0-.66-1.67,2.82,2.82,0,0,0-1.75-.5h-3.64v4.18Z"
                style="fill:#0092c8"
            />
            <svg:path
                id="letterC"
                d="M3.33,-3.68a3.36,3.36,0,0,0-.75-.84,3.49,3.49,0,0,0-2.2-.77,3.9,3.9,0,0,0-1.92.44,3.62,3.62,0,0,0-1.28,1.17,5.1,5.1,0,0,0-.71,1.67,8.33,8.33,0,0,0-.22,1.94,7.75,7.75,0,0,0,.22,1.86,5,5,0,0,0,.71,1.63,3.65,3.65,0,0,0,1.28,1.16,3.9,3.9,0,0,0,1.92.44,3.09,3.09,0,0,0,2.4-.94,4.34,4.34,0,0,0,1.06-2.47h3.24a7.74,7.74,0,0,1-.66,2.58,6.19,6.19,0,0,1-1.41,2,6,6,0,0,1-2,1.24,7.5,7.5,0,0,1-2.58.43,7.8,7.8,0,0,1-3.14-.61,6.72,6.72,0,0,1-2.35-1.67,7.38,7.38,0,0,1-1.47-2.5,9.17,9.17,0,0,1-.51-3.1,9.48,9.48,0,0,1,.51-3.16,7.59,7.59,0,0,1,1.47-2.55,6.71,6.71,0,0,1,2.35-1.7,8.16,8.16,0,0,1,5.52-.26,6.44,6.44,0,0,1,2,1.06,5.69,5.69,0,0,1,1.46,1.72,6.13,6.13,0,0,1,.73,2.34H3.72A2.74,2.74,0,0,0,3.33,-3.68Z"
                style="fill:#0092c8"
            />
            <svg:path
                id="letterD"
                d="M1.07,-7.24a7.84,7.84,0,0,1,2.74.47,6,6,0,0,1,2.19,1.41,6.52,6.52,0,0,1,1.45,2.34,9.49,9.49,0,0,1,.52,3.3,10.53,10.53,0,0,1-.43,3.07,6.77,6.77,0,0,1-1.29,2.43,6,6,0,0,1-2.15,1.61,7.28,7.28,0,0,1-3,.59h-6.56V-7.24Zm-.23,12.4a4.29,4.29,0,0,0,1.41-.23,3.09,3.09,0,0,0,1.21-.78,3.89,3.89,0,0,0,.85-1.42,6.21,6.21,0,0,0,.32-2.13,8.88,8.88,0,0,0-.22-2.08,4.15,4.15,0,0,0-.73-1.59,3.27,3.27,0,0,0-1.35-1,5.4,5.4,0,0,0-2.08-.35h-2.39V5.12Z"
                style="fill:#0092c8"
            />
        </svg:defs>
        <!-- TODO abstract styles perhaps? -->
        <!-- title text -->
        @if (options.showTitle) {
            <svg:text
                x="0"
                y="22"
                style="font-size:23.26750946044922px;fill:#0092c8;"
            >
                <svg:tspan
                    style="font-family:Roboto-Bold, Roboto;font-weight:700"
                >
                    {{
                        patternTypeMap[pattern.type] | translate: languageLocale
                    }}
                </svg:tspan>
            </svg:text>
        }
        <!-- part below title -->
        <svg:g
            [attr.transform]="
                SVG.outputTranslate(0, options.showTitle ? 33 : 0)
            "
        >
            @if (!options.isOverlay) {
                <ng-container>
                    <!-- top line with sigmas -->
                    <svg:path
                        d="M4.13,7.34H.29V6.15H4.13Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M7.51,5.18H8.61a2.4,2.4,0,0,0,1.62-.54,1.81,1.81,0,0,0,.59-1.42,1.78,1.78,0,0,0-2-2,2.09,2.09,0,0,0-1.51.54,1.89,1.89,0,0,0-.56,1.43H5.29A2.92,2.92,0,0,1,6.28.9,3.62,3.62,0,0,1,8.81,0a3.58,3.58,0,0,1,2.54.86,3.1,3.1,0,0,1,.92,2.38,2.51,2.51,0,0,1-.48,1.45,2.92,2.92,0,0,1-1.32,1,2.81,2.81,0,0,1,1.46,1,2.75,2.75,0,0,1,.52,1.69,3.13,3.13,0,0,1-1,2.45,3.77,3.77,0,0,1-2.62.9,3.87,3.87,0,0,1-2.62-.87,2.9,2.9,0,0,1-1-2.3H6.65A1.87,1.87,0,0,0,7.24,10a2.24,2.24,0,0,0,1.58.54A2.2,2.2,0,0,0,10.43,10,2.12,2.12,0,0,0,11,8.45a1.93,1.93,0,0,0-.61-1.53,2.67,2.67,0,0,0-1.77-.55H7.51Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M22.52,4.3H20.28a3.87,3.87,0,0,1,1.57,3.31v.13a4.33,4.33,0,0,1-.48,2,3.65,3.65,0,0,1-3.32,2,3.49,3.49,0,0,1-2.76-1.19,4.68,4.68,0,0,1-1-3.2v-.1a4.83,4.83,0,0,1,.46-2.15A3.54,3.54,0,0,1,16,3.64a3.66,3.66,0,0,1,2-.54h4.53Zm-6.8,3.15a3.74,3.74,0,0,0,.63,2.29,2.16,2.16,0,0,0,3.43,0,4.1,4.1,0,0,0,.63-2.45,3.42,3.42,0,0,0-.63-2.16A2.07,2.07,0,0,0,18,4.3a2,2,0,0,0-1.7.8A3.76,3.76,0,0,0,15.71,7.45Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M177.49,7.34h-3.84V6.15h3.84Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M186.26,11.61h-7.5v-1l4-4.4a9.45,9.45,0,0,0,1.22-1.62,2.71,2.71,0,0,0,.33-1.29,2.05,2.05,0,0,0-.54-1.47,1.9,1.9,0,0,0-1.45-.57,2.25,2.25,0,0,0-1.69.62,2.36,2.36,0,0,0-.6,1.72h-1.46a3.38,3.38,0,0,1,1-2.56,3.78,3.78,0,0,1,2.73-1,3.63,3.63,0,0,1,2.53.84,2.86,2.86,0,0,1,.93,2.23q0,1.69-2.16,4l-3.07,3.33h5.75Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M195.87,4.3h-2.23a3.87,3.87,0,0,1,1.57,3.31v.13a4.33,4.33,0,0,1-.48,2,3.65,3.65,0,0,1-3.32,2,3.49,3.49,0,0,1-2.76-1.19,4.68,4.68,0,0,1-1-3.2v-.1a4.83,4.83,0,0,1,.46-2.15,3.54,3.54,0,0,1,1.32-1.49,3.66,3.66,0,0,1,2-.54h4.53Zm-6.8,3.15a3.74,3.74,0,0,0,.63,2.29,2.16,2.16,0,0,0,3.43,0,4.1,4.1,0,0,0,.63-2.45,3.42,3.42,0,0,0-.63-2.16,2.07,2.07,0,0,0-1.73-.81,2,2,0,0,0-1.7.8A3.76,3.76,0,0,0,189.07,7.45Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M358.16,7.34h-3.84V6.15h3.84Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M364.21,11.61h-1.46V1.91L359.81,3V1.67L364,.1h.23Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M376.54,4.3h-2.23a3.87,3.87,0,0,1,1.57,3.31v.13a4.33,4.33,0,0,1-.48,2,3.65,3.65,0,0,1-3.32,2,3.49,3.49,0,0,1-2.76-1.19,4.68,4.68,0,0,1-1-3.2v-.1a4.83,4.83,0,0,1,.46-2.15,3.54,3.54,0,0,1,1.32-1.49,3.66,3.66,0,0,1,2-.54h4.53Zm-6.8,3.15a3.74,3.74,0,0,0,.63,2.29,2.16,2.16,0,0,0,3.43,0,4.1,4.1,0,0,0,.63-2.45,3.42,3.42,0,0,0-.63-2.16,2.07,2.07,0,0,0-1.73-.81,2,2,0,0,0-1.7.8A3.76,3.76,0,0,0,369.74,7.45Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M552.35,6.73a6.66,6.66,0,0,1-.87,3.8,3.63,3.63,0,0,1-5.44,0,6.31,6.31,0,0,1-.91-3.63V5A6.51,6.51,0,0,1,546,1.23a3.69,3.69,0,0,1,5.46,0,6.28,6.28,0,0,1,.9,3.65Zm-1.46-2A5.33,5.33,0,0,0,550.38,2a1.79,1.79,0,0,0-1.64-.85A1.76,1.76,0,0,0,547.1,2a5.21,5.21,0,0,0-.53,2.59V7a5.42,5.42,0,0,0,.54,2.74,1.78,1.78,0,0,0,1.63.89,1.76,1.76,0,0,0,1.6-.83,5.22,5.22,0,0,0,.55-2.63Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M724.31,5.47h3.19V6.84h-3.19v3.62h-1.46V6.84h-3.19V5.47h3.19V2.12h1.46Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M733.91,11.61h-1.46V1.91L729.51,3V1.67L733.68.1h.23Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M746.24,4.3H744a3.87,3.87,0,0,1,1.57,3.31v.13a4.33,4.33,0,0,1-.48,2,3.65,3.65,0,0,1-3.32,2A3.49,3.49,0,0,1,739,10.58a4.68,4.68,0,0,1-1-3.2v-.1a4.83,4.83,0,0,1,.46-2.15,3.54,3.54,0,0,1,1.32-1.49,3.66,3.66,0,0,1,2-.54h4.53Zm-6.8,3.15a3.74,3.74,0,0,0,.63,2.29,2.16,2.16,0,0,0,3.43,0,4.1,4.1,0,0,0,.63-2.45,3.42,3.42,0,0,0-.63-2.16,2.07,2.07,0,0,0-1.73-.81,2,2,0,0,0-1.7.8A3.76,3.76,0,0,0,739.44,7.45Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M904.09,5.47h3.19V6.84h-3.19v3.62h-1.46V6.84h-3.19V5.47h3.19V2.12h1.46Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M916.41,11.61h-7.5v-1l4-4.4a9.45,9.45,0,0,0,1.22-1.62,2.71,2.71,0,0,0,.33-1.29,2.05,2.05,0,0,0-.54-1.47,1.9,1.9,0,0,0-1.45-.57,2.25,2.25,0,0,0-1.69.62,2.36,2.36,0,0,0-.6,1.72h-1.46a3.38,3.38,0,0,1,1-2.56,3.78,3.78,0,0,1,2.73-1A3.63,3.63,0,0,1,915,.84a2.86,2.86,0,0,1,.93,2.23q0,1.69-2.16,4l-3.07,3.33h5.75Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M926,4.3h-2.23a3.87,3.87,0,0,1,1.57,3.31v.13a4.33,4.33,0,0,1-.48,2,3.65,3.65,0,0,1-3.32,2,3.49,3.49,0,0,1-2.76-1.19,4.68,4.68,0,0,1-1-3.2v-.1a4.83,4.83,0,0,1,.46-2.15,3.54,3.54,0,0,1,1.32-1.49,3.66,3.66,0,0,1,2-.54H926Zm-6.8,3.15a3.74,3.74,0,0,0,.63,2.29,2.16,2.16,0,0,0,3.43,0,4.1,4.1,0,0,0,.63-2.45,3.42,3.42,0,0,0-.63-2.16,2.07,2.07,0,0,0-1.73-.81,2,2,0,0,0-1.7.8A3.76,3.76,0,0,0,919.21,7.45Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M1074.37,5.47h3.19V6.84h-3.19v3.62h-1.46V6.84h-3.19V5.47h3.19V2.12h1.46Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M1081.3,5.18h1.09a2.4,2.4,0,0,0,1.62-.54,1.81,1.81,0,0,0,.59-1.42,1.78,1.78,0,0,0-2-2,2.09,2.09,0,0,0-1.51.54,1.89,1.89,0,0,0-.56,1.43h-1.46a2.92,2.92,0,0,1,1-2.26,3.62,3.62,0,0,1,2.53-.9,3.58,3.58,0,0,1,2.54.86,3.1,3.1,0,0,1,.92,2.38,2.51,2.51,0,0,1-.48,1.45,2.92,2.92,0,0,1-1.32,1,2.81,2.81,0,0,1,1.46,1,2.75,2.75,0,0,1,.52,1.69,3.13,3.13,0,0,1-1,2.45,3.77,3.77,0,0,1-2.62.9,3.87,3.87,0,0,1-2.62-.87,2.9,2.9,0,0,1-1-2.3h1.46A1.87,1.87,0,0,0,1081,10a2.24,2.24,0,0,0,1.58.54,2.2,2.2,0,0,0,1.61-.55,2.12,2.12,0,0,0,.56-1.58,1.93,1.93,0,0,0-.61-1.53,2.67,2.67,0,0,0-1.77-.55h-1.09Z"
                        style="fill:#c8caca"
                    />
                    <svg:path
                        d="M1096.3,4.3h-2.23a3.87,3.87,0,0,1,1.57,3.31v.13a4.33,4.33,0,0,1-.48,2,3.65,3.65,0,0,1-3.32,2,3.49,3.49,0,0,1-2.76-1.19,4.68,4.68,0,0,1-1-3.2v-.1a4.83,4.83,0,0,1,.46-2.15,3.54,3.54,0,0,1,1.32-1.49,3.66,3.66,0,0,1,2-.54h4.53Zm-6.8,3.15a3.74,3.74,0,0,0,.63,2.29,2.16,2.16,0,0,0,3.43,0,4.1,4.1,0,0,0,.63-2.45,3.42,3.42,0,0,0-.63-2.16,2.07,2.07,0,0,0-1.73-.81,2,2,0,0,0-1.7.8A3.76,3.76,0,0,0,1089.49,7.45Z"
                        style="fill:#c8caca"
                    />
                    <!-- top gray line -->
                    <svg:rect
                        id="Top_Bar"
                        data-name="Top Bar"
                        y="16.97"
                        width="1098"
                        height="3.68"
                        style="fill:#c8caca"
                    />
                </ng-container>
            }

            <!-- this is the pattern -->
            @if (!this.options.isOverlay) {
                <svg:g transform="translate(0,20.65)">
                    <!-- These create vertical lines inside pattern -->
                    <svg:line
                        x1="915"
                        y1="4.5"
                        x2="915"
                        [attr.y2]="graphHeight() - 4.5"
                        style="fill: none;stroke:#c8caca;stroke-miterlimit: 10;stroke-width:1.18743134819734px"
                    />
                    <svg:line
                        x1="732"
                        y1="4.5"
                        x2="732"
                        [attr.y2]="graphHeight() - 4.5"
                        style="fill: none;stroke:#c8caca;stroke-miterlimit: 10;stroke-width:1.18743134819734px"
                    />
                    <svg:line
                        x1="549"
                        y1="4.5"
                        x2="549"
                        [attr.y2]="graphHeight() - 4.5"
                        style="fill: none;stroke:#c8caca;stroke-miterlimit: 10;stroke-width:1.18743134819734px"
                    />
                    <svg:line
                        x1="366"
                        y1="4.5"
                        x2="366"
                        [attr.y2]="graphHeight() - 4.5"
                        style="fill: none;stroke:#c8caca;stroke-miterlimit: 10;stroke-width:1.18743134819734px"
                    />
                    <svg:line
                        x1="183"
                        y1="4.5"
                        x2="183"
                        [attr.y2]="graphHeight() - 4.5"
                        style="fill: none;stroke:#c8caca;stroke-miterlimit: 10;stroke-width:1.18743134819734px"
                    />
                </svg:g>
            }

            <!-- These create the lines between the circles -->
            <svg:line
                id="A-B_Line"
                data-name="A-B Line"
                [attr.x1]="findLimitedXValue('A')"
                [attr.y1]="factorYValues[0]"
                [attr.x2]="findLimitedXValue('B')"
                [attr.y2]="factorYValues[1]"
                style="fill: none;stroke:#231f20;stroke-miterlimit: 10;stroke-width:1.63076860506315px"
            />
            <svg:line
                id="B-C_Line"
                data-name="B-C Line"
                [attr.x1]="findLimitedXValue('B')"
                [attr.y1]="factorYValues[1]"
                [attr.x2]="findLimitedXValue('C')"
                [attr.y2]="factorYValues[2]"
                style="fill: none;stroke:#231f20;stroke-miterlimit: 10;stroke-width:1.67634260995414px"
            />
            <svg:line
                id="C-D_Line"
                data-name="C-D Line"
                [attr.x1]="findLimitedXValue('C')"
                [attr.y1]="factorYValues[2]"
                [attr.x2]="findLimitedXValue('D')"
                [attr.y2]="factorYValues[3]"
                style="fill: none;stroke:#231f20;stroke-miterlimit: 10;stroke-width:1.70093180280567px"
            />

            <!-- #c8caca for no highlight and #272626 for highlight -->

            @for (factorInfo of factorDataHeights; track factorInfo) {
                <ng-container>
                    @if (!options.isOverlay) {
                        <svg:text
                            #leftText
                            x="0"
                            [attr.y]="factorInfo.y + 7"
                            text-anchor="start"
                            [attr.fill]="
                                shouldBold(true, factorInfo.factor)
                                    ? '#272626'
                                    : '#c8caca'
                            "
                            style="font-size: 18.4px;"
                        >
                            {{
                                behavioralFactorLabelMap[factorInfo.factor][
                                    'left'
                                ] | translate: languageLocale
                            }}
                        </svg:text>
                    }
                    @if (!options.isOverlay) {
                        <svg:text
                            #rightText
                            x="1098"
                            [attr.y]="factorInfo.y + 7"
                            text-anchor="end"
                            [attr.fill]="
                                shouldBold(false, factorInfo.factor)
                                    ? '#272626'
                                    : '#c8caca'
                            "
                            style="font-size: 18.4px;"
                        >
                            {{
                                behavioralFactorLabelMap[factorInfo.factor][
                                    'right'
                                ] | translate: languageLocale
                            }}
                        </svg:text>
                    }
                    <!-- the edge arrows -->
                    <!-- I could have done left/right as an ngFor - but that seemed overkill -->
                    @if (shouldShowTriangle(true, factorInfo.factor)) {
                        <svg:g
                            [attr.transform]="
                                SVG.outputTranslate(1098, factorInfo.y)
                            "
                        >
                            <svg:rect
                                x="-35"
                                y="-11"
                                width="35"
                                height="22"
                                style="fill:#fff"
                            />
                            <svg:polygon
                                points="-1,0 -15.9,8.6 -15.9,-8.6"
                                style="fill:#0092c8;stroke:#010101;stroke-miterlimit: 10;stroke-width:1.22655013499922px"
                            />
                        </svg:g>
                    }
                    @if (shouldShowTriangle(false, factorInfo.factor)) {
                        <svg:g
                            [attr.transform]="
                                SVG.outputTranslate(0, factorInfo.y)
                            "
                        >
                            <svg:rect
                                x="0"
                                y="-11"
                                width="35"
                                height="22"
                                style="fill:#fff"
                            />
                            <svg:polygon
                                points="1,0 15.9,8.6 15.9,-8.6"
                                style="fill:#0092c8;stroke:#010101;stroke-miterlimit: 10;stroke-width:1.22655013499922px"
                            />
                        </svg:g>
                    }
                    <!-- the circles -->
                    <svg:g
                        #circle
                        [attr.transform]="
                            SVG.outputTranslate(
                                findLimitedXValue(factorInfo.factor),
                                factorInfo.y
                            )
                        "
                        [ngClass]="'circle' + factorInfo.factor"
                        [attr.sigmaValue]="pattern[factorInfo.factor]"
                    >
                        <svg:circle
                            [attr.cx]="0"
                            cy="0"
                            r="16.91"
                            style="fill:#fff;stroke:#010101;stroke-miterlimit: 10;stroke-width:1.37813433510092px"
                        />
                        <svg:use
                            [attr.xlink:href]="getLetterId(factorInfo.factor)"
                        />
                    </svg:g>
                </ng-container>
            }

            <!-- the hover: these have to be separate from the circles for Z index reasons -->
            @for (factorInfo of factorDataHeights; track factorInfo) {
                <ng-container>
                    <!-- offscreen text used for managing spacing -->
                    <svg:text
                        x="0"
                        y="-10000"
                        style="font-weight: bold; font-size: 18.4px;"
                    >
                        {{
                            behavioralFactorLabelMap[factorInfo.factor].name
                                | translate: languageLocale
                        }}
                    </svg:text>
                    <svg:text
                        [ngStyle]="{ 'font-size': hoverTextFontSize + 'px' }"
                        x="0"
                        y="-10000"
                    >
                        {{
                            hoverTextMap[factorInfo.factor]
                                | translate: this.languageLocale
                        }}
                    </svg:text>
                    @if (!options.isOverlay) {
                        <svg:g
                            [ngClass]="[
                                factorInfo.factor === hoveredFactor
                                    ? 'highlight--active'
                                    : '',
                                'highlight' + factorInfo.factor
                            ]"
                            [attr.transform]="
                                SVG.outputTranslate(
                                    findLimitedXValue(factorInfo.factor),
                                    factorInfo.y
                                )
                            "
                        >
                            <svg:rect
                                #hoverSection
                                [attr.x]="getHighlightStart(factorInfo.factor)"
                                y="-30"
                                [attr.width-old]="
                                    getBoundedWidth(factorInfo.factor)
                                "
                                [attr.width]="
                                    getHoverSectionWidth(factorInfo.factor)
                                "
                                height="60"
                                rx="9"
                                ry="9"
                                fill="black"
                            ></svg:rect>
                            <svg:text
                                [attr.x]="
                                    isNegative(factorInfo.factor) ? 25 : -25
                                "
                                y="-5"
                                fill="white"
                                [attr.text-anchor]="
                                    isNegative(factorInfo.factor)
                                        ? 'start'
                                        : 'end'
                                "
                                style="font-weight: bold; font-size: 18.4px;"
                            >
                                {{
                                    behavioralFactorLabelMap[factorInfo.factor]
                                        .name | translate: languageLocale
                                }}
                            </svg:text>
                            <svg:text
                                [attr.x]="
                                    isNegative(factorInfo.factor) ? 25 : -25
                                "
                                y="16"
                                fill="white"
                                [attr.text-anchor]="
                                    isNegative(factorInfo.factor)
                                        ? 'start'
                                        : 'end'
                                "
                                style="font-size: 16.4px;"
                            >
                                {{
                                    hoverTextMap[factorInfo.factor]
                                        | translate: languageLocale
                                }}
                            </svg:text>
                            <svg:circle
                                cx="0"
                                cy="0"
                                r="16.91"
                                style="fill:#fff;stroke:#010101;stroke-miterlimit: 10;stroke-width:1.37813433510092px"
                            />
                            <svg:use
                                [attr.xlink:href]="
                                    getLetterId(factorInfo.factor)
                                "
                            />
                        </svg:g>
                    }
                </ng-container>
            }

            <!-- bottom line area -->
            @if (!options.isOverlay) {
                <svg:g
                    [attr.transform]="SVG.outputTranslate(0, bottomRowHeight())"
                >
                    <!-- blue bar at bottom -->
                    <svg:g>
                        <svg:rect
                            width="1098"
                            height="16.86"
                            [attr.fill]="SVG.getGradientUrl('linearGradient')"
                        />
                        <svg:g id="Measurements">
                            <svg:text
                                x="10"
                                y="13.2"
                                text-anchor="start"
                                fill="#fff"
                                style="font-size: 13.4px; font-weight: bolder; letter-spacing:1.2px; text-transform: uppercase"
                            >
                                {{
                                    'text.common-terms.low'
                                        | translate: this.languageLocale
                                }}
                            </svg:text>
                            <svg:text
                                x="1088"
                                y="13.2"
                                text-anchor="end"
                                fill="#fff"
                                style="font-size: 13.4px; font-weight: bolder; letter-spacing:1.2px; text-transform: uppercase"
                            >
                                {{
                                    'text.common-terms.high'
                                        | translate: this.languageLocale
                                }}
                            </svg:text>
                        </svg:g>
                    </svg:g>
                    <!-- tick marks on bottom line -->
                    <svg:g>
                        <svg:line
                            x1="73.2"
                            y1="0"
                            x2="73.2"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="109.8"
                            y1="0"
                            x2="109.8"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="146.4"
                            y1="0"
                            x2="146.4"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="183"
                            y1="0"
                            x2="183"
                            y2="16.86"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="219.6"
                            y1="0"
                            x2="219.6"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="256.2"
                            y1="0"
                            x2="256.2"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="292.8"
                            y1="0"
                            x2="292.8"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="329.4"
                            y1="0"
                            x2="329.4"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="366"
                            y1="0"
                            x2="366"
                            y2="16.86"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="402.6"
                            y1="0"
                            x2="402.6"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="439.2"
                            y1="0"
                            x2="439.2"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="475.8"
                            y1="0"
                            x2="475.8"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="512.4"
                            y1="0"
                            x2="512.4"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="585.6"
                            y1="0"
                            x2="585.6"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="622.2"
                            y1="0"
                            x2="622.2"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="658.8"
                            y1="0"
                            x2="658.8"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="695.4"
                            y1="0"
                            x2="695.4"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="732"
                            y1="0"
                            x2="732"
                            y2="16.86"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="768.6"
                            y1="0"
                            x2="768.6"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="805.2"
                            y1="0"
                            x2="805.2"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="841.8"
                            y1="0"
                            x2="841.8"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="878.4"
                            y1="0"
                            x2="878.4"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="915"
                            y1="0"
                            x2="915"
                            y2="16.86"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="951.6"
                            y1="0"
                            x2="951.6"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="988.2"
                            y1="0"
                            x2="988.2"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                        <svg:line
                            x1="1024.8"
                            y1="0"
                            x2="1024.8"
                            y2="6.92"
                            style="fill: none;stroke:#fff;stroke-miterlimit: 10;stroke-width:1.51967823185229px"
                        />
                    </svg:g>
                    <!-- midpoint triangle -->
                    <svg:polygon
                        points="549 0 560.25 16.86 537.75 16.86"
                        style="fill:#231f20"
                    />
                    <!-- row of bottom text including M Score, Copyright, scoreid -->
                    <svg:g transform="translate(0, 38.24)">
                        <!-- M Score at bottom -->
                        @if (!options.isOverlay) {
                            <svg:text
                                x="0"
                                text-anchor="start"
                                style="font-size:16.054378509521484px; fill:#0092c8;"
                            >
                                M: {{ pattern.M }}
                            </svg:text>
                        }
                        @if (shouldShowScoreId()) {
                            <svg:text
                                x="549"
                                text-anchor="middle"
                                style="font-size: 12px; fill:#231f20;"
                            >
                                {{
                                    'EnteredAsScoreId'
                                        | translate: this.languageLocale
                                }}:
                                {{ scoreId }}
                            </svg:text>
                        }
                        @if (options.showCopyright) {
                            <svg:text
                                x="1098"
                                text-anchor="end"
                                style="font-size: 12px; fill:#231f20;"
                            >
                                {{
                                    'text.assess.checklist.pdf.copyright'
                                        | translateFormatLocale
                                            : this.languageLocale
                                            : copyrightYear
                                }}
                            </svg:text>
                        }
                    </svg:g>
                </svg:g>
            }
        </svg:g>
    `,
    standalone: false
})
export class BehavioralPatternImageComponent implements OnInit {
    @Input('singleBehavioralPattern')
    pattern: Pattern;
    @Input()
    options = {
        showCopyright: false,
        showScoreId: false,
        showTitle: false,
        isOverlay: false
    };
    @Input()
    scoreId: string;
    @Input()
    hoveredFactor: string;
    @Input()
    showE = false;
    @Input()
    languageLocale: string = null;

    SVG: SVGUtilities;
    hoverTextFontSize = 16.4;
    factorYValues = [53, 93, 133, 173, 213];

    patternTypeString: string;
    copyrightYear: number;
    behavioralFactorLabelMap = behavioralFactorLabelMap;
    hoverTextMap = {
        A: 'label.common-terms.factora-drive.short',
        B: 'label.common-terms.factorb-drive.short',
        C: 'label.common-terms.factorc-drive.short',
        D: 'label.common-terms.factord-drive.short',
        E: 'label.common-terms.factore-drive.short'
    };
    patternTypeMap = {
        0: 'image.label.self',
        1: 'image.label.selfconcept',
        2: 'image.label.synthesis'
    };

    // Strongly type factor to BehavioralFactor so downstream method calls expecting BehavioralFactor don't receive a plain string.
    factorDataHeights: { factor: BehavioralFactor; y: number }[];

    constructor(
        public TR: TranslationService,
        private config: ConfigurationService,
        util: Util
    ) {
        this.SVG = util.svg;
        if (!this.languageLocale) {
            this.languageLocale = this.TR.currentLocale;
        }
        this.copyrightYear = this.config.getCopyrightYear();
    }

    ngOnInit(): void {
        this.patternTypeString = this.getPatternTypeString();
        this.factorDataHeights = this.getFactorDataHeights();
    }

    getHoverSectionWidth(factor: BehavioralFactor): number {
        return (
            this.SVG.computeSvgTextWidth(
                this.TR.key(this.hoverTextMap[factor], this.languageLocale),
                this.hoverTextFontSize
            ).width + 70
        );
    }

    getPatternTypeString(): string {
        switch (this.pattern.type) {
            case ScoreInfoType.Self:
                return 'image.label.self';
            case ScoreInfoType.SelfConcept:
                return 'image.label.selfconcept';
            case ScoreInfoType.Synthesis:
                return 'image.label.synthesis';
        }
    }

    // Note: this is coupled to wrapper where the definitions live
    getLetterId(factor: BehavioralFactor): string {
        return `#letter${factor}`;
    }

    findXValue(factor: BehavioralFactor): number {
        return (this.pattern[factor] + 3) * 183;
    }

    findLimitedXValue(factor: BehavioralFactor): number {
        if (this.offRightEdge(factor)) {
            return 1059;
        }
        if (this.offLeftEdge(factor)) {
            return 39;
        }
        return this.findXValue(factor);
    }

    hasE(): boolean {
        if (!this.showE) {
            return false;
        }
        return (
            !this.options.isOverlay &&
            this.pattern.E !== undefined &&
            this.pattern.E !== null
        );
    }

    isNegative(factor: BehavioralFactor): boolean {
        return this.pattern[factor] < 0;
    }

    getFactorDataHeights(): { factor: BehavioralFactor; y: number }[] {
        const factorInfo: { factor: BehavioralFactor; y: number }[] = [
            { factor: 'A', y: this.factorYValues[0] },
            { factor: 'B', y: this.factorYValues[1] },
            { factor: 'C', y: this.factorYValues[2] },
            { factor: 'D', y: this.factorYValues[3] }
        ];
        if (this.hasE()) {
            factorInfo.push({ factor: 'E', y: this.factorYValues[4] });
        }
        return factorInfo;
    }
    graphHeight(): number {
        // 182 = 2*31 + 3*40
        return 182 + (this.hasE() ? 40 : 0);
    }
    shouldBold(low: boolean, factor: BehavioralFactor): boolean {
        if (low) {
            return this.pattern[factor] < 0.2;
        }
        return this.pattern[factor] > -0.2;
    }
    shouldShowTriangle(rightSide: boolean, factor: BehavioralFactor): boolean {
        return (
            (rightSide && this.offRightEdge(factor)) ||
            (!rightSide && this.offLeftEdge(factor))
        );
    }
    bottomRowHeight(): number {
        // TODO less magic numbers
        return 205 + (this.hasE() ? 40 : 0);
    }

    getHighlightStart(factor: BehavioralFactor) {
        if (this.isNegative(factor)) {
            const xPos = this.findLimitedXValue(factor);
            if (xPos - 30 < 0) {
                return -xPos;
            }
            return -30;
        }
        return 30 - this.getHoverSectionWidth(factor);
    }

    getBoundedWidth(factor: BehavioralFactor) {
        const xPos = this.findLimitedXValue(factor);
        const hoverWidth = this.getHoverSectionWidth(factor);
        if (xPos + 30 > 1098) {
            return hoverWidth + 1098 - xPos - 30;
        }
        if (xPos - 30 < 0) {
            return hoverWidth - 30 + xPos;
        }
        return hoverWidth;
    }

    shouldShowScoreId() {
        return (
            !this.options.isOverlay && this.options.showScoreId && this.scoreId
        );
    }
    private offRightEdge(factor: BehavioralFactor): boolean {
        return this.findXValue(factor) > 1080;
    }

    private offLeftEdge(factor: BehavioralFactor): boolean {
        return this.findXValue(factor) < 18;
    }
}
